function imageSrcSetToString(obj) {
    let str = '';
    let prefix = '';
    obj.forEach((item) => {
        str += prefix + `${item.imageUrl} ${item.width}w`;
        prefix = ', ';
    });
    return str;
}

export { imageSrcSetToString };
